<template>
    <van-dialog
        v-model="show"
        :z-index="100000"
        :confirm-button-text="$t('确定')"
        width="75%"
        confirm-button-color="#FF6907"
        class="reject-dialog"
        @confirm="handleRejectConfirm"
    >
        <div class="reject-box">
            <div class="reject-title">{{ $t('登录安全提醒') }}</div>
            <div class="reject-text">
                <span>{{ $t('您的账号已在其他地方登录，请确认是否为本人操作。如非本人操作，请重新登录当前账号或') }}</span>
                <span class="link"><a href="tel:29796988">2979 6988</a></span>
                <span>{{ $t('联系客服') }}</span>
            </div>
        </div>
    </van-dialog>
</template>

<script>
import { isCMHK, isInOutsideH5 } from '@/utils'
import goto, { getUrlParams } from '@/utils/goto'
import MYLINK_JSBRIDGE from '@fs/jsbridge/dist/lib/mylinkJsBridge.js'

export default {
    name: 'CMHKLogout',
    props: {
        close: {
            type: Function,
        },
    },
    data() {
        return {
            show: false,
        }
    },
    methods: {
        // 确认
        async handleRejectConfirm() {
            this.close?.()

            const store = (await import('@/store/login'))?.default
            store?.dispatch('user/clearUserInfo')
            if (isCMHK()) {
                MYLINK_JSBRIDGE.backToHomePage()
            } else if (isInOutsideH5()) {
                // 需要保存路径的页面：tradeRecom、corpW8
                if (location.href.includes('tradeRecom') || location.href.includes('corpW8') || location.href.includes('startAccount')) {
                    goto('login', {
                        query: {
                            path: encodeURIComponent(location.href),
                            ...getUrlParams(),
                        }
                    })
                } else {
                    goto('login')
                }
                return
            } else {
                window.close()
            }
        },
    },
}
</script>

<style lang="less" scoped>
.reject-dialog {
    .reject-box {
        padding: 16px 16px 28px;
        color: #181818;

        .reject-title {
            margin-bottom: 16px;
            font-weight: 600;
            font-size: 16px;
            text-align: center;
        }

        .reject-text {
            font-size: 14px;
            line-height: 20px;

            .link {
                margin: 0 8px;
                color: #ff6907;
                cursor: pointer;
            }
        }
    }
}
</style>
